// Study-safe display names. Participants never see real names or usernames
// (which could reveal a person's role, e.g. "Guesser One"). Instead every user
// is shown as "User A", "User B", … derived deterministically from their numeric
// id (1 -> A, 26 -> Z, 27 -> AA, …). The real full_name / username stay in the
// database and admin exports untouched — this only changes what is rendered.

// Excel-style column letters: 1 -> A, 26 -> Z, 27 -> AA, 28 -> AB, …
export function userLetter(idOrUser) {
  const id = (idOrUser && typeof idOrUser === 'object') ? idOrUser.id : idOrUser;
  const n = Number(id);
  if (!Number.isFinite(n) || n < 1) return '?';
  let x = Math.floor(n) - 1;
  let s = '';
  for (;;) {
    s = String.fromCharCode(65 + (x % 26)) + s;
    x = Math.floor(x / 26) - 1;
    if (x < 0) break;
  }
  return s;
}

// Full label shown in place of a name, e.g. "User C".
export function userLabel(idOrUser) {
  const letter = userLetter(idOrUser);
  return letter === '?' ? 'User' : `User ${letter}`;
}

// Single character for avatar circles, e.g. "C".
export function userInitial(idOrUser) {
  return userLetter(idOrUser);
}
